import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../config/config";
import ThemePicker from "../../components/ThemePicker";
import { defaultCities, cityImages } from "./data";
import {
  Navbar,
  HeroSection,
  WhyChooseSection,
  ValueProposition,
  HowItWorks,
  FeaturesSection,
  CitiesSection,
  StatsSection,
  Testimonials,
  CTASection,
  Footer,
  AboutUsSection,
} from "./components";
import FAQSection from "./components/FAQSection";

function LandingPage() {
  const [cities, setCities] = useState(defaultCities);
  const [stats, setStats] = useState({
    totalProperties: 0,
    totalTenants: 0,
    totalLandlords: 0,
    totalCities: 0,
  });

  useEffect(() => {
    const fetchLandingData = async () => {
      try {
        const statsResponse = await axios.get(`${BASE_URL}/landing/stats`);
        if (statsResponse.data?.success) {
          const data = statsResponse.data.data;
          setStats({
            totalProperties: data.totalProperties || 0,
            totalTenants: data.totalTenants || 0,
            totalLandlords: data.totalLandlords || 0,
            totalCities: data.totalCities || 6,
          });
          // if (data.citiesData && data.citiesData.length > 0) {
          //   const updatedCities = data.citiesData.map((city) => ({
          //     ...city,
          //     image: cityImages[city.name] || "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400",
          //   }));
          //   setCities(updatedCities);
          // }
        }
      } catch (error) {
        // Keep default values
      }
    };
    fetchLandingData();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
      <ThemePicker position="top-right" light={false} />

      <Navbar scrollToSection={scrollToSection} />
      <HeroSection stats={stats} />
      <WhyChooseSection />
      <ValueProposition />
      <HowItWorks />
      <FeaturesSection />
      <CitiesSection cities={cities} />
      {/* <StatsSection stats={stats} /> */}
      {/* <Testimonials /> */}
      <AboutUsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </Box>
  );
}

export default LandingPage;
